const InfoSvg: React.FC = () => {
  return (
    <svg
      width="245"
      height="126"
      viewBox="0 0 245 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_138_3230)">
        <path
          d="M12.2998 117.724L22.8273 101.038L12.2949 119.541L12.2893 121.443C11.5382 121.434 10.7948 121.405 10.0589 121.356L10.9176 96.9328L10.9063 96.7441L10.9256 96.708L11.0074 94.4002L0 76.1127L11.0187 92.6719L11.0517 93.1607L11.7003 74.7078L2.23751 55.787L11.7743 71.4653L12.2179 33.2175L12.2199 33.0902L12.2215 33.2155L12.4375 63.3713L21.4797 51.3054L12.4295 65.9686L12.3875 82.4851L20.7774 66.5334L12.3829 84.9133L12.3597 94.0974L24.5467 71.8869L12.3501 97.3013L12.2998 117.724Z"
          fill="#D0CDE1"
        />
        <path
          d="M160.065 47.2951H157.106V68.2823H160.065V47.2951Z"
          fill="#3F3D56"
        />
        <path
          d="M50.5488 2.63112L49.4357 5.37006L158.958 49.7679L160.071 47.0289L50.5488 2.63112Z"
          fill="#3F3D56"
        />
        <path
          d="M245 120.502C240.416 128.15 -0.241812 127.508 0.122851 120.501C4.70686 112.853 245.364 113.495 245 120.502Z"
          fill="#D0CDE1"
        />
        <path
          d="M214.819 89.5651H189.07V99.6153H214.819V89.5651Z"
          fill="#3F3D56"
        />
        <path
          d="M212.451 98.4329H85.4818V109.666H212.451V98.4329Z"
          fill="#3F3D56"
        />
        <path
          d="M191.586 104.049H161.101V65.7698H183.891L191.586 85.076V104.049Z"
          fill="#D0CDE1"
        />
        <path
          d="M178.859 68.1345H165.837V81.1407H178.859V68.1345Z"
          fill="white"
        />
        <path
          d="M188.626 81.2885H180.339V68.2824H183.891L188.626 81.2885Z"
          fill="white"
        />
        <path
          d="M169.388 88.5305H166.428V94.1468H169.388V88.5305Z"
          fill="#3F3D56"
        />
        <path
          d="M182.855 76.559H183.003C183.748 76.559 184.463 76.8548 184.991 77.3814C185.518 77.9081 185.814 78.6223 185.814 79.3671C185.814 80.1119 185.518 80.8261 184.991 81.3528C184.463 81.8794 183.748 82.1752 183.003 82.1752H182.855V76.559Z"
          fill="#3F3D56"
        />
        <path
          d="M72.7552 98.4329H72.9032C73.6489 98.4329 74.3641 98.7288 74.8914 99.2554C75.4187 99.782 75.7149 100.496 75.7149 101.241C75.7149 101.986 75.4187 102.7 74.8914 103.227C74.3641 103.753 73.6489 104.049 72.9032 104.049H72.7552V98.4329Z"
          fill="#3F3D56"
        />
        <path
          d="M203.424 98.3905C207.934 98.3905 211.991 100.573 214.806 104.049H220.59L214.967 88.4046L188.774 83.2452L189.514 104.049H192.042C194.857 100.573 198.914 98.3905 203.424 98.3905Z"
          fill="#D0CDE1"
        />
        <path
          d="M203.72 120.603C210.831 120.603 216.595 114.846 216.595 107.744C216.595 100.643 210.831 94.8858 203.72 94.8858C196.61 94.8858 190.846 100.643 190.846 107.744C190.846 114.846 196.61 120.603 203.72 120.603Z"
          fill="#3F3D56"
        />
        <path
          d="M203.72 114.512C207.462 114.512 210.496 111.482 210.496 107.744C210.496 104.007 207.462 100.977 203.72 100.977C199.978 100.977 196.944 104.007 196.944 107.744C196.944 111.482 199.978 114.512 203.72 114.512Z"
          fill="#D0CDE1"
        />
        <path
          d="M87.4055 120.455C93.6169 120.455 98.6522 115.426 98.6522 109.222C98.6522 103.019 93.6169 97.9896 87.4055 97.9896C81.1941 97.9896 76.1588 103.019 76.1588 109.222C76.1588 115.426 81.1941 120.455 87.4055 120.455Z"
          fill="#3F3D56"
        />
        <path
          d="M87.4055 115.134C90.6747 115.134 93.3249 112.487 93.3249 109.222C93.3249 105.957 90.6747 103.31 87.4055 103.31C84.1364 103.31 81.4862 105.957 81.4862 109.222C81.4862 112.487 84.1364 115.134 87.4055 115.134Z"
          fill="#D0CDE1"
        />
        <path
          d="M161.989 60.4491H155.774V105.232H161.989V60.4491Z"
          fill="#3F3D56"
        />
        <path
          d="M161.989 97.1028H72.6073V99.7631H161.989V97.1028Z"
          fill="#3F3D56"
        />
        <path
          d="M122.251 80.3801L24.774 106.866L25.4733 109.433L122.95 82.9471L122.251 80.3801Z"
          fill="#3F3D56"
        />
        <path
          d="M115.598 83.6069L113.928 84.8322L124.182 98.7685L125.852 97.5432L115.598 83.6069Z"
          fill="#3F3D56"
        />
        <path
          d="M184.63 81.8796H181.671V83.062H184.63V81.8796Z"
          fill="#3F3D56"
        />
        <path
          d="M158.586 90.7475H119.814C119.743 90.7475 119.674 90.7219 119.62 90.6754C119.567 90.6289 119.531 90.5647 119.521 90.4944C119.511 90.4241 119.526 90.3525 119.565 90.2926C119.603 90.2328 119.662 90.1888 119.73 90.1686L157.614 78.936C157.656 78.9235 157.7 78.9205 157.744 78.9274C157.787 78.9342 157.829 78.9507 157.865 78.9757C157.902 79.0006 157.932 79.0333 157.954 79.0715C157.976 79.1096 157.989 79.1522 157.993 79.1961L158.881 90.4287C158.884 90.4693 158.879 90.5102 158.865 90.5487C158.852 90.5872 158.831 90.6226 158.803 90.6525C158.775 90.6825 158.742 90.7064 158.704 90.7227C158.667 90.739 158.626 90.7475 158.586 90.7475ZM121.851 90.1563H158.265L157.431 79.6066L121.851 90.1563Z"
          fill="#3F3D56"
        />
        <path
          d="M53.5943 77.7413H53.5916L45.0951 77.6613C45.0537 77.6609 45.0127 77.6519 44.975 77.6347C44.9373 77.6175 44.9036 77.5925 44.8761 77.5615C44.8486 77.5304 44.828 77.494 44.8155 77.4545C44.8031 77.415 44.7991 77.3733 44.8038 77.3321L49.2184 38.8611C49.2267 38.789 49.2613 38.7225 49.3155 38.6741C49.3697 38.6258 49.4399 38.5991 49.5125 38.5991H49.5138C49.5867 38.5995 49.6569 38.6266 49.711 38.6755C49.7651 38.7243 49.7992 38.7913 49.8069 38.8637L53.8887 77.4147C53.8931 77.4559 53.8887 77.4975 53.8759 77.5369C53.8631 77.5764 53.8421 77.6126 53.8143 77.6434C53.7866 77.6742 53.7527 77.6989 53.7148 77.7157C53.6769 77.7326 53.6358 77.7413 53.5943 77.7413ZM45.4294 77.0733L53.2651 77.1469L49.5007 41.5939L45.4294 77.0733Z"
          fill="#3F3D56"
        />
        <path
          d="M216.902 93.8858L216.763 93.9381C216.066 94.2016 215.292 94.1775 214.613 93.8712C213.933 93.565 213.403 93.0015 213.139 92.3049C212.875 91.6083 212.899 90.8356 213.206 90.1567C213.513 89.4779 214.077 88.9485 214.774 88.685L214.913 88.6327L216.902 93.8858Z"
          fill="#3F3D56"
        />
        <path
          d="M36.8731 95.6096L28.6172 97.9175L28.984 99.2264L37.2399 96.9184L36.8731 95.6096Z"
          fill="#3F3D56"
        />
        <path
          d="M96.6565 79.25L95.0629 80.1188L30.326 98.2161L29.3649 97.0238C27.6995 94.9831 26.635 92.5202 26.2902 89.9102C26.0458 87.9613 26.2246 85.9072 27.5858 84.6569L25.1135 64.7422L60.9166 54.685L77.8979 61.9828C77.8979 61.9828 84.4025 60.0416 89.1893 63.4668C90.7044 64.552 92.0481 66.1748 92.9568 68.57L93.7394 70.8281L96.6565 79.25Z"
          fill="#0033C6"
        />
        <path
          d="M82.3462 91.1881C86.9308 91.1881 90.6473 87.4763 90.6473 82.8975C90.6473 78.3187 86.9308 74.6069 82.3462 74.6069C77.7617 74.6069 74.0452 78.3187 74.0452 82.8975C74.0452 87.4763 77.7617 91.1881 82.3462 91.1881Z"
          fill="#3F3D56"
        />
        <path
          d="M82.3463 87.261C84.7592 87.261 86.7153 85.3074 86.7153 82.8975C86.7153 80.4876 84.7592 78.534 82.3463 78.534C79.9334 78.534 77.9773 80.4876 77.9773 82.8975C77.9773 85.3074 79.9334 87.261 82.3463 87.261Z"
          fill="#D0CDE1"
        />
        <path
          d="M42.9013 102.215C47.4858 102.215 51.2023 98.5032 51.2023 93.9244C51.2023 89.3456 47.4858 85.6338 42.9013 85.6338C38.3167 85.6338 34.6002 89.3456 34.6002 93.9244C34.6002 98.5032 38.3167 102.215 42.9013 102.215Z"
          fill="#3F3D56"
        />
        <path
          d="M42.9013 98.2879C45.3142 98.2879 47.2703 96.3343 47.2703 93.9244C47.2703 91.5145 45.3142 89.5609 42.9013 89.5609C40.4884 89.5609 38.5323 91.5145 38.5323 93.9244C38.5323 96.3343 40.4884 98.2879 42.9013 98.2879Z"
          fill="#D0CDE1"
        />
        <path
          d="M72.0272 62.2126L46.3419 69.393L44.1779 61.671L60.5588 57.0916L72.0272 62.2126Z"
          fill="white"
        />
        <path
          d="M41.0329 62.5501L30.8113 65.4076L32.9754 73.1296L43.197 70.2722L41.0329 62.5501Z"
          fill="white"
        />
        <path
          d="M49.2665 74.7853L47.9561 75.1517L48.653 77.6384L49.9634 77.2721L49.2665 74.7853Z"
          fill="#3F3D56"
        />
        <path
          d="M70.2655 66.5157L69.8987 65.2068L67.4088 65.9029L67.7756 67.2117L70.2655 66.5157Z"
          fill="#3F3D56"
        />
        <path
          d="M66.9543 60.7515L67.0985 60.7112C67.8249 60.5082 68.6023 60.6016 69.2597 60.971C69.9171 61.3404 70.4007 61.9555 70.604 62.681C70.8073 63.4065 70.7137 64.1829 70.3439 64.8395C69.974 65.4961 69.3581 65.979 68.6317 66.1821L68.4876 66.2224L66.9543 60.7515Z"
          fill="#3F3D56"
        />
        <path
          d="M93.7394 70.8281C92.7784 71.2122 91.7124 71.2453 90.7293 70.9216C89.7462 70.5978 88.909 69.938 88.3652 69.0582C87.8215 68.1785 87.606 67.1353 87.7567 66.1125C87.9074 65.0896 88.4148 64.1527 89.1893 63.4668C90.7045 64.552 92.0481 66.1748 92.9568 68.5699L93.7394 70.8281Z"
          fill="#3F3D56"
        />
        <path
          d="M50.8537 2.66034H47.894V45.8171H50.8537V2.66034Z"
          fill="#3F3D56"
        />
        <path
          d="M49.3739 8.27665C51.6623 8.27665 53.5174 6.42386 53.5174 4.13832C53.5174 1.85279 51.6623 0 49.3739 0C47.0855 0 45.2303 1.85279 45.2303 4.13832C45.2303 6.42386 47.0855 8.27665 49.3739 8.27665Z"
          fill="#3F3D56"
        />
        <path
          d="M158.585 52.0246C160.874 52.0246 162.729 50.1718 162.729 47.8862C162.729 45.6007 160.874 43.7479 158.585 43.7479C156.297 43.7479 154.442 45.6007 154.442 47.8862C154.442 50.1718 156.297 52.0246 158.585 52.0246Z"
          fill="#3F3D56"
        />
      </g>
      <defs>
        <clipPath id="clip0_138_3230">
          <rect width="245" height="126" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoSvg;
